import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  StyledHelperTextContainer,
  StyledHelperTextTypography,
} from './styled';

const GET_IN_TOUCH_LINK = 'mailto:help@loudly.com';
const HelperText = () => {
  const { t } = useTranslation();

  return (
    <StyledHelperTextContainer>
      <StyledHelperTextTypography>
        {t('account:youtubeChannel:whitelistContainer:helperText')}
        <Link href={GET_IN_TOUCH_LINK}>
          {t('account:youtubeChannel:whitelistContainer:getInTouch')}
        </Link>
        {' .'}
      </StyledHelperTextTypography>
    </StyledHelperTextContainer>
  );
};

export default HelperText;
